import profileImage from "./../resources/ghulam.jpg";

const About = () => {
  return (
    <section className="container about">
      <div className="grid">
        <h1 className="large-text about__heading" data-drop-text="About Me">
          About Me
        </h1>
        <div className="grid__item">
          <p className="small-text mb-3">
            I am Mohammad Ghulam Azad Ansari, a software developer with less than a year of experience in the field. I am currently pursuing a master's degree in Computer Applications and have gained a strong foundation in software development through various projects and coursework.
          </p>
          <p className="small-text mb-3">
            In my professional career, I have consistently shown my ability to learn new technologies and adapt to new environments. I am highly motivated and committed to delivering excellent results.
          </p>
          <p className="small-text mb-3">
            In my free time, I enjoy reading and watching K-dramas, keeping up with industry trends and progress, and exploring new places. Thank you for considering my background and expertise.
          </p>
          {/* <p className="small-text">I love to work with Java and Python</p> */}
        </div>
        <div className="grid__item">
          <figure className="about__figure">
            <img
              src={profileImage}
              alt="md ghulam azasd ansari"
              className="about__img"
            />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default About;
